import React, { Component } from "react";
import moment from "moment";
import less from "../search.module.scss";
import { Select, message, DatePicker } from "antd";
import Fetch from "../../../utils/fetch";
const { RangePicker } = DatePicker;
const { Option } = Select;
class DriverSearch extends Component {
  state = {
    drivers: [],
    buttonLoading: false,
    fromDate: moment()
      .startOf("day")
      .valueOf(),
    toDate: moment()
      .endOf("day")
      .valueOf()
  };

  async componentDidMount() {
    try {
      const drivers = await this.getBusDriver();
      this.setState({ drivers });
    } catch (err) {
      message.error(err);
    }
  }

  getBusDriver = async () => {
    try {
      const url = `/bus-tracker/getCrewName`;

      const options = {
        method: "get"
      };
      const response = await Fetch(url, options);
      if (response) {
        const data = response.map(obj => {
          return {
            mobileNo: obj.mobileNo.toString(),
            _id: obj._id,
            name: obj.name
          };
        });

        return data;
      } else {
        return [];
      }
    } catch (err) {
      console.log(err);

      return [];
    }
  };

  search = async () => {
    try {
      const { selectedDriver, fromDate, toDate } = this.state;
      let body = {};
      const url = `/workAuditHistory/facialTasks`;
      if (selectedDriver) {
        body.selectedDriver = selectedDriver;
      }
      if (fromDate && toDate) {
        body.fromDate = fromDate.valueOf();
        body.toDate = toDate.valueOf();
      }
      if ((fromDate && !toDate) || (toDate && !fromDate)) {
        message.error("please select both date");
        return;
      }
      const options = {
        method: "post",
        data: body
      };
      const response = await Fetch(url, options);

      this.props.fetched(response);
    } catch (err) {
      console.log(err);
      this.props.fetched([]);
    }
  };
  onTimeRangeSelect = value => {
    if (!value) {
      const fromDate = moment()
        .startOf("day")
        .valueOf();
      const toDate = moment()
        .endOf("day")
        .valueOf();
      this.setState({ fromDate, toDate });
    } else {
      const [startTime, endTime] = value;
      const fromDate = moment(startTime)
        .startOf("day")
        .valueOf();
      const toDate = moment(endTime)
        .endOf("day")
        .valueOf();
      this.setState({ fromDate, toDate });
    }
  };

  render() {
    const {
      buttonLoading,
      selectedDriver,
      drivers,
      fromDate,
      toDate
    } = this.state;
    return (
      <div className={less.auditSearch}>
        <span>Profile Photo Review</span>
        <div className={less.selectables}>
          <div className={less.dateSelect}>
            <RangePicker
              allowClear
              value={[moment(fromDate), moment(toDate)]}
              format="YYYY-MM-DD"
              onChange={this.onTimeRangeSelect}
            />
          </div>
          <Select
            allowClear
            placeholder="Bus Driver/Marshal"
            showSearch
            style={{ width: 320 }}
            value={selectedDriver}
            onChange={value =>
              this.setState({
                selectedDriver: value
              })
            }
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {drivers.map(s => (
              <Option value={s._id} key={s._id}>
                {`${s.name}-${s.mobileNo}`}
              </Option>
            ))}
          </Select>
          <button
            disabled={buttonLoading}
            className={less.searchBtn}
            onClick={this.search}
          >
            <span>Search</span>
          </button>
        </div>
      </div>
    );
  }
}

export default DriverSearch;
